(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animaciones"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!document.documentElement.classList.contains('animar')) return;

    var elementos = document.querySelectorAll('.animar-entrada');

    if (!('IntersectionObserver' in window)) {
      elementos.forEach(function (el) {
        el.classList.add('entro');
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('entro');
          observador.unobserve(entrada.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    elementos.forEach(function (el) {
      observador.observe(el);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["boton-crear-fijo"] && !Shopify.designMode) return;
  try {
    (function () {
    var fijo = document.querySelector('.crear-fijo');
    var objetivos = document.querySelectorAll('.oculta-crear-fijo');
    if (!fijo || !objetivos.length || !('IntersectionObserver' in window)) return;

    var visibles = new Set();
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) visibles.add(entrada.target);
        else visibles.delete(entrada.target);
      });
      var ocultar = visibles.size > 0;
      fijo.classList.toggle('crear-fijo--oculto', ocultar);
      fijo.toggleAttribute('inert', ocultar);
    });

    objetivos.forEach(function (el) {
      observador.observe(el);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carrito-controlador"] && !Shopify.designMode) return;
  try {
    (function () {
    // Cart controller, shared by the drawer and the cart page. Bound at page
    // load whatever the cart holds (all listeners are delegated on document). Each place is a
    // [data-carrito-raiz] element (with its section id) whose
    // [data-carrito-contenido] is replaced by the freshly rendered section
    // after every change, so Liquid is the only template.
    var cola = Promise.resolve();

    function cajon() {
      return document.getElementById('CarritoCajon');
    }

    function raices() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-carrito-raiz]'));
    }

    function secciones() {
      return raices().map(function (r) {
        return r.dataset.seccion;
      });
    }

    function lineaDe(el) {
      return el.closest('[data-linea]');
    }

    // Quantity changes for a line plus every complemento linked to it
    function cambiosPara(linea, cantidad) {
      var cambios = {};
      cambios[linea.dataset.clave] = cantidad;
      (linea.dataset.vinculadas || '')
        .split(',')
        .filter(Boolean)
        .forEach(function (clave) {
          cambios[clave] = cantidad;
        });
      return cambios;
    }

    // The control of this line only (not one of a nested complemento)
    function controlDe(linea, nombre) {
      var controles = linea.querySelectorAll('[data-foco]');
      for (var i = 0; i < controles.length; i++) {
        if (controles[i].dataset.foco === nombre && lineaDe(controles[i]) === linea) return controles[i];
      }
      return null;
    }

    function buscarLinea(raiz, clave) {
      var lineas = raiz.querySelectorAll('[data-linea]');
      for (var i = 0; i < lineas.length; i++) {
        if (lineas[i].dataset.clave === clave) return lineas[i];
      }
      return null;
    }

    // Focus and open "Ver detalles" survive the re-render
    function recordarEstado() {
      var activo = document.activeElement;
      var foco = null;
      if (activo && activo.closest && activo.closest('[data-carrito-contenido]')) {
        var linea = lineaDe(activo);
        foco = {
          raiz: activo.closest('[data-carrito-raiz]'),
          clave: linea ? linea.dataset.clave : null,
          control: activo.dataset ? activo.dataset.foco : null,
        };
      }
      var abiertos = [];
      document.querySelectorAll('[data-carrito-contenido] details[open]').forEach(function (d) {
        var linea = lineaDe(d);
        if (linea) abiertos.push(linea.dataset.clave);
      });
      return { foco: foco, abiertos: abiertos };
    }

    function restaurarEstado(previo) {
      raices().forEach(function (raiz) {
        raiz.querySelectorAll('[data-carrito-contenido] details').forEach(function (d) {
          var linea = lineaDe(d);
          if (linea && previo.abiertos.indexOf(linea.dataset.clave) !== -1) d.open = true;
        });
      });
      var f = previo.foco;
      if (!f || !f.raiz) return;
      var destino = null;
      if (f.clave && f.control) {
        var linea = buscarLinea(f.raiz, f.clave);
        if (linea) destino = controlDe(linea, f.control);
      }
      // The line is gone (removed): go to the drawer or page title
      if (!destino) destino = f.raiz.querySelector('[data-carrito-titulo]');
      if (destino) destino.focus();
    }

    function actualizarEncabezado(contenido) {
      var enlace = document.querySelector('.encabezado__carrito');
      if (!enlace || !contenido) return;
      var conteo = Number(contenido.dataset.conteo) || 0;
      var contador = enlace.querySelector('.encabezado__contador');
      if (conteo === 0) {
        if (contador) contador.remove();
      } else {
        if (!contador) {
          contador = document.createElement('span');
          contador.className = 'encabezado__contador';
          contador.setAttribute('aria-hidden', 'true');
          enlace.appendChild(contador);
        }
        contador.textContent = conteo;
      }
      var icono = enlace.querySelector('svg');
      if (icono && contenido.dataset.etiqueta) icono.setAttribute('aria-label', contenido.dataset.etiqueta);
    }

    function pintar(htmlPorSeccion) {
      var parser = new DOMParser();
      raices().forEach(function (raiz) {
        var html = htmlPorSeccion[raiz.dataset.seccion];
        if (!html) return;
        var nuevo = parser.parseFromString(html, 'text/html').querySelector('[data-carrito-contenido]');
        var actual = raiz.querySelector('[data-carrito-contenido]');
        if (nuevo && actual) actual.replaceWith(nuevo);
      });
      actualizarEncabezado(document.querySelector('[data-carrito-contenido]'));
    }

    function ocupado(si) {
      document.querySelectorAll('[data-carrito-contenido]').forEach(function (c) {
        c.setAttribute('aria-busy', si ? 'true' : 'false');
      });
    }

    function anunciar(raiz) {
      var region = raiz.querySelector('[data-carrito-anuncio]');
      var contenido = raiz.querySelector('[data-carrito-contenido]');
      if (!region || !contenido) return;
      region.textContent = '';
      setTimeout(function () {
        region.textContent = contenido.dataset.anuncio || '';
      }, 100);
    }

    function mostrarError(raiz, si) {
      var error = raiz.querySelector('[data-carrito-error]');
      if (error) error.hidden = !si;
    }

    // Re-render without changing anything (also used after an error)
    async function refrescar() {
      var raiz = raices()[0];
      if (!raiz) return;
      try {
        var url = raiz.dataset.rutaRaiz + '?sections=' + encodeURIComponent(secciones().join(','));
        var respuesta = await fetch(url, { headers: { Accept: 'application/json' } });
        if (respuesta.ok) pintar(await respuesta.json());
      } catch (e) {
        // Keep what is shown; the next page load is up to date anyway
      }
    }

    async function enviar(cambios, raiz) {
      var previo = recordarEstado();
      ocupado(true);
      try {
        var respuesta = await fetch(raiz.dataset.rutaActualizar, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: cambios, sections: secciones().join(',') }),
        });
        if (!respuesta.ok) throw new Error('HTTP ' + respuesta.status);
        var carrito = await respuesta.json();
        pintar(carrito.sections || {});
        mostrarError(raiz, false);
        anunciar(raiz);
      } catch (e) {
        mostrarError(raiz, true);
        await refrescar();
      }
      ocupado(false);
      restaurarEstado(previo);
    }

    // One update at a time, in order (fast taps on + never race)
    function actualizar(cambios, raiz) {
      cola = cola.then(function () {
        return enviar(cambios, raiz);
      });
      return cola;
    }

    function cantidadDe(campo) {
      var linea = lineaDe(campo);
      var raiz = linea && linea.closest('[data-carrito-raiz]');
      if (!raiz) return;
      var n = parseInt(campo.value, 10);
      if (isNaN(n) || n < 0) return;
      actualizar(cambiosPara(linea, n), raiz);
    }

    function abrirCajon() {
      var c = cajon();
      if (!c || c.open) return;
      c.showModal();
      document.querySelectorAll('[data-abrir-carrito]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }

    function cerrarCajon() {
      var c = cajon();
      if (c && c.open) c.close();
    }

    var c = cajon();
    if (c) {
      c.addEventListener('close', function () {
        document.querySelectorAll('[data-abrir-carrito]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
      });
    }

    document.addEventListener('click', function (e) {
      var objetivo = e.target;
      if (!objetivo || !objetivo.closest) return;

      if (objetivo.closest('[data-abrir-carrito]') && cajon()) {
        e.preventDefault();
        abrirCajon();
        return;
      }
      if (objetivo.closest('[data-cerrar-carrito]')) {
        cerrarCajon();
        return;
      }
      // Click on the backdrop: the event target is the dialog itself
      if (objetivo === cajon()) {
        cerrarCajon();
        return;
      }

      // On a product page the personalizer starts a new design in place;
      // anywhere else, the link goes to the Crear page
      var crearOtro = objetivo.closest('[data-crear-otro]');
      if (crearOtro) {
        e.preventDefault();
        cerrarCajon();
        var evento = new CustomEvent('carrito:crear-otro', { cancelable: true });
        if (document.dispatchEvent(evento)) window.location.href = crearOtro.href;
        return;
      }

      var paso = objetivo.closest('[data-paso]');
      var quitar = objetivo.closest('[data-quitar]');
      if (!paso && !quitar) return;
      var linea = lineaDe(paso || quitar);
      var raiz = linea && linea.closest('[data-carrito-raiz]');
      if (!raiz) return;
      e.preventDefault();
      if (quitar) {
        actualizar(cambiosPara(linea, 0), raiz);
        return;
      }
      var campo = controlDe(linea, 'cantidad');
      if (!campo) return;
      var nueva = Math.max(0, (parseInt(campo.value, 10) || 0) + Number(paso.dataset.paso));
      campo.value = nueva;
      actualizar(cambiosPara(linea, nueva), raiz);
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-cantidad]')) cantidadDe(e.target);
    });

    // Enter in a quantity field: update through the API (keeps linked lines
    // together) instead of posting the whole form. "Pagar" still submits.
    document.addEventListener('submit', function (e) {
      var formulario = e.target;
      if (!formulario.matches || !formulario.matches('[data-carrito-formulario]')) return;
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      var activo = document.activeElement;
      if (activo && activo.matches && activo.matches('[data-cantidad]')) cantidadDe(activo);
    });

    // The personalizer added a design: refresh and open the drawer. Cancelling
    // the event tells it not to show its own confirmation bar.
    document.addEventListener('carrito:agregado', function (e) {
      if (!cajon()) return;
      e.preventDefault();
      refrescar().then(abrirCajon);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-movil"] && !Shopify.designMode) return;
  try {
    (function () {
    function botonesDe(dialogo) {
      return document.querySelectorAll('[data-abrir-menu][aria-controls="' + dialogo.id + '"]');
    }

    document.addEventListener('click', function (e) {
      var abrir = e.target.closest('[data-abrir-menu]');
      if (abrir) {
        var dialogo = document.getElementById(abrir.getAttribute('aria-controls'));
        if (!dialogo || dialogo.open) return;
        dialogo.showModal();
        abrir.setAttribute('aria-expanded', 'true');
        return;
      }

      var cerrar = e.target.closest('[data-cerrar-menu]');
      if (cerrar) {
        cerrar.closest('dialog').close();
        return;
      }

      // Click on the backdrop: the event target is the dialog itself
      if (e.target.matches('dialog.menu-movil')) e.target.close();
    });

    document.querySelectorAll('dialog.menu-movil').forEach(function (dialogo) {
      dialogo.addEventListener('close', function () {
        botonesDe(dialogo).forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
      });
    });

    // Close the drawer if the viewport grows to the desktop layout
    window.matchMedia('(min-width: 1024px)').addEventListener('change', function (mq) {
      if (!mq.matches) return;
      document.querySelectorAll('dialog.menu-movil[open]').forEach(function (d) {
        d.close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["producto-simple"] && !Shopify.designMode) return;
  try {
    // Plain product page (snippets/producto-simple). Progressive: the form
  // works without this script (radios / select carry the variant id, the
  // form posts to the cart page). With it:
  // - changing the variant updates the price, the button (Agotado when sold
  //   out), the URL (?variant=) and puts that variant's photo first;
  // - sold-out colours can be chosen to see them (the button stays disabled);
  // - add to cart goes through /cart/add.js and fires carrito:agregado, which
  //   the cart drawer (snippets/carrito-controlador) cancels to open itself;
  //   if nobody cancels it (no drawer on the page) it goes to the cart page.
  (function () {
    function iniciar(raiz) {
      var nodoDatos = raiz.querySelector('[data-producto-datos]');
      var formulario = raiz.querySelector('[data-producto-formulario]');
      if (!nodoDatos || !formulario) return;
      var datos;
      try {
        datos = JSON.parse(nodoDatos.textContent);
      } catch (e) {
        return;
      }
      var precio = raiz.querySelector('[data-precio]');
      var fotos = raiz.querySelector('[data-producto-fotos]');
      var error = raiz.querySelector('[data-producto-error]');
      var boton = formulario.querySelector('button[type="submit"]');
      var radios = raiz.querySelectorAll('[data-variante-opcion]');
      var selector = raiz.querySelector('[data-variante-select]');
      var enviando = false;

      function variante(id) {
        for (var i = 0; i < datos.variantes.length; i++) {
          if (String(datos.variantes[i].id) === String(id)) return datos.variantes[i];
        }
        return null;
      }

      function idElegido() {
        if (selector) return selector.value;
        for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].value;
        var oculto = formulario.querySelector('input[name="id"]');
        return oculto ? oculto.value : null;
      }

      function mostrarBoton(v) {
        if (!boton) return;
        var disponible = !!(v && v.disponible);
        boton.disabled = !disponible || enviando;
        boton.textContent = disponible ? datos.agregar : datos.agotado;
      }

      function aplicar(v, conUrl) {
        if (!v) return;
        if (precio) precio.textContent = v.precio;
        mostrarBoton(v);
        if (error) error.hidden = true;
        // that variant's photo first in the gallery
        if (fotos && v.medio) {
          var foto = fotos.querySelector('[data-medio="' + v.medio + '"]');
          if (foto && fotos.firstElementChild !== foto) {
            fotos.insertBefore(foto, fotos.firstElementChild);
            var img = foto.querySelector('img');
            if (img) img.setAttribute('loading', 'eager');
          }
        }
        if (conUrl && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) {}
        }
      }

      // Sold-out colours stay visible and selectable (the button says Agotado)
      for (var i = 0; i < radios.length; i++) {
        radios[i].disabled = false;
        radios[i].addEventListener('change', function (e) {
          aplicar(variante(e.target.value), true);
        });
      }
      if (selector) {
        // in the select, sold-out entries stay disabled (no room for a label)
        selector.addEventListener('change', function () {
          aplicar(variante(selector.value), true);
        });
      }
      mostrarBoton(variante(idElegido()));

      formulario.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var v = variante(idElegido());
        if (enviando || (v && !v.disponible)) return;
        enviando = true;
        mostrarBoton(v);
        if (error) error.hidden = true;
        window
          .fetch(raiz.getAttribute('data-ruta-agregar'), {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(formulario),
          })
          .then(function (r) {
            return r.json().then(function (cuerpo) {
              if (!r.ok) throw cuerpo || {};
              return cuerpo;
            });
          })
          .then(function () {
            enviando = false;
            mostrarBoton(variante(idElegido()));
            var agregado = new CustomEvent('carrito:agregado', { cancelable: true });
            // nobody opened a drawer: go to the cart page
            if (document.dispatchEvent(agregado)) window.location.href = raiz.getAttribute('data-ruta-carrito');
          })
          .catch(function (problema) {
            enviando = false;
            mostrarBoton(variante(idElegido()));
            if (error) {
              error.textContent = (problema && problema.description) || datos.error;
              error.hidden = false;
            }
          });
      });
    }

    var raices = document.querySelectorAll('[data-producto-simple]');
    for (var i = 0; i < raices.length; i++) iniciar(raices[i]);
  })();
  } catch(e) { console.error(e); }
})();

})();
